import React from "react";
import { Link } from 'react-router-dom'
import pimg1 from '../../images/clients/1.png'
import pimg2 from '../../images/clients/2.png'
import pimg3 from '../../images/clients/3.png'
import pimg4 from '../../images/clients/4.png'
import pimg5 from '../../images/clients/5.png'
import pimg6 from '../../images/clients/6.png'
import pimg7 from '../../images/clients/7.png'
import pimg8 from '../../images/clients/8.png'

const partners = [
     {
         pImg: pimg1,
         link: 'https://frint.in',
     },
     {
         pImg: pimg2,
         link: 'https://medavas.com/listing/dixeeta-psychologist-and-therapist-in-guwahati-assam-india/?fbclid=PAZXh0bgNhZW0CMTEAAacPTS4OLVS-XIu1dqqyjnfhCLJOFAH4TENTARiY4qdytQiEBG9l_CzMrlaSdA_aem_DZLvjzzNez2aPoO-H5ePrA',
     },
     {
         pImg: pimg3,
         link: 'https://officetribe.in/',
     },
     {
         pImg: pimg4,
         link: 'https://www.instagram.com/forkandfunnel/',
     },
    //  {
    //      pImg: pimg5,
    //  },
    //  {
    //      pImg: pimg6,
    //  },
    //  {
    //      pImg: pimg7,
    //  },
    //  {
    //      pImg: pimg8,
    //  },
]


const PartnerSection = (props) => {

    return (

        <section className="clients-one">
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Sponsors and Partners</div>
                    <h2 className="sec-title_heading">Appreciate Our Kind Partners</h2>
                </div>
                <div className="row clearfix">
                    {partners.map((partner, pitem) => (
                        <div className="clients-one_column col-lg-3 col-md-4 col-sm-6" key={pitem}>
                            <a href={partner.link} target="_blank" rel="noopener noreferrer"><img src={partner.pImg} alt="" /></a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default PartnerSection;